import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {validateSignUp} from "./form-validation-rules";
import formHandler from "../util/form-handler";
import axios from "axios";
import Logo from "../../images/SAlogoold.png";



const SignUp = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showText, setShowText] = useState(false);
    const [error, setError] = useState(null);


    const {
        values,
        errors,
        handleChange,
        handleOnBlur,
        handleSubmit,
    } = formHandler(signUp, validateSignUp);

    function signUp() {
        setIsLoading(true);
    }

    useEffect(() => {
        if (!isLoading) {
            return;
        }
        const queryParams = new URLSearchParams(props.location.search);
        values.key = queryParams.get("hash");
        values.email = queryParams.get("email");

        axios.post(process.env.REACT_APP_HOST + '/user-name-password', values)
            .then(function (response) {
                setIsLoading(false);
                props.history.push('/login');
            })
            .catch(function (error) {
                if (error.response.status === 422) {
                    errors.message=error.response.data.message;
                }
            })
            .finally(()=>{
                setIsLoading(false);
            });

    }, [isLoading]);


    return (
        <div className="login-background" id="login">
            <div className="login-inner">
                <div className="login-box">
                    <div className="login-logo">
                        <img className="login-logo-image" src={Logo} alt="logo"/>
                    </div>

                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-group m-b-16">
                            <label htmlFor="email">Username</label>
                            <input type="text" value={values.username || ''} onChange={handleChange}
                                   onBlur={handleOnBlur}
                                   className={errors.username ? "form-control warning-input" : "form-control active-input"}
                                   name="username" placeholder="Enter your username"/>
                            {errors.username && (<p className="warning-input-msg">{errors.username}</p>)}
                        </div>
                        <div className="form-group m-b-6">
                            <label htmlFor="pwd">Password</label>
                            <input type={!showText ? "password" : "text"} value={values.password || ''}
                                   onChange={handleChange}
                                   onBlur={handleOnBlur}
                                   className={errors.password ? "form-control warning-input" : "form-control"}
                                   name="password" placeholder="Enter your password"/>
                            <span className="fa fa-fw fa-eye field-icon toggle-password"
                                  onClick={() => setShowText(!showText)}/>
                            {errors.password && (<p className="warning-input-msg">{errors.password}</p>)}

                        </div>
                        <div className="form-group m-b-6">
                            <label htmlFor="pwd">Confirm Password</label>
                            <input type={!showText ? "password" : "text"} value={values.confirmPassword || ''}
                                   onBlur={handleOnBlur}
                                   onChange={handleChange}
                                   className={errors.confirmPassword ? "form-control warning-input" : "form-control"}
                                   name="confirmPassword" placeholder="Enter your password"/>
                            <span className="fa fa-fw fa-eye field-icon toggle-password"
                                  onClick={() => setShowText(!showText)}/>
                            {errors.confirmPassword && (<p className="warning-input-msg">{errors.confirmPassword}</p>)}
                            {errors.message && (<div className={"login-warning-msg"}>{errors.message}</div>)}
                        </div>
                        <button className="btn btn-sa-primary w-100 m-b-14">SIGN UP</button>
                        <div className="login-text-btn m-b-9">
                            Already have an account? <Link to={"/login"}>Sign In</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>);
};


export default SignUp
